var _g, _circle, _text, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0ea5e9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a8a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0369a1",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 15)",
    id: "outerShapeGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25 L25 0 L50 25 L25 50 Z",
    fill: "url(#gradient)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25 L25 12.5 L37.5 25 L25 37.5 Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "scale",
    begin: "0s",
    dur: "3s",
    values: "1;1.1;1",
    repeatCount: "indefinite"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 40,
    r: 4,
    fill: "white",
    opacity: 0.9,
    id: "centerDot"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "scale",
    begin: "0.5s",
    dur: "1.5s",
    values: "1;1.5;1",
    repeatCount: "indefinite",
    additive: "sum",
    origin: "35 40"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "url(#textGradient)"
  }, "Nexi")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 55,
    x2: 140,
    y2: 55,
    stroke: "url(#gradient)",
    strokeWidth: 2,
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/Partner1.7e34d91ea35cf88b8d3d96a9458d2867.svg";
export { ForwardRef as ReactComponent };